/* eslint-disable */
export default {
  forward: 'Weiterl.',
  cancel: 'Abbrechen',
  customNumber: 'Benutzerdefinierte Nummer',
} as const;

// @key: @#@"forward"@#@ @source: @#@"Forward"@#@
// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"customNumber"@#@ @source: @#@"Custom number"@#@
